import { useFeatureFlags } from '@brightdrop/feature-flags-client';

import { NOT_EQUIPPED_FLAG } from '~/common/models/featureFlags.model';

export const useNotEquippedFeatureFlag = (): boolean => {
  const { getFlag } = useFeatureFlags();
  return Boolean(getFlag(NOT_EQUIPPED_FLAG));
};
